import { ThemeIcon, NavLink } from '@mantine/core';
import { IconUser } from '@tabler/icons';
import { AppRoutePaths } from '../../../utils/enums';

interface UsersLinkProps {
  navigate(to: string): void;
  themeColor: 'dark' | 'light';
}

export function UsersLink({ navigate, themeColor }: UsersLinkProps) {
  return (
    <NavLink
      styles={{
        label: {
          color: themeColor === 'light' ? '#373A40' : '#FBFBFB',
        },
      }}
      label="Usuários"
      fw="bold"
      color=""
      icon={
        <ThemeIcon color="blue" variant="light">
          <IconUser size={16} />
        </ThemeIcon>
      }
      childrenOffset={28}
    >
      <NavLink
        label="Novo"
        onClick={() => navigate(AppRoutePaths.USERS_CREATE)}
      />
      <NavLink label="Listagem" onClick={() => navigate(AppRoutePaths.USERS)} />
    </NavLink>
  );
}
